import React, { useState } from 'react'
import { Form, Input, message, Button } from 'antd'
import { FaLock } from 'react-icons/fa'
import { translations } from '../../utils/constants'
import { secureApi } from '../../Config/api'
import { POST } from '../../utils/apis'

// 0-4 score used for the strength meter: length, mixed case, digits, symbols.
const scorePassword = (pwd = '') => {
  let score = 0
  if (pwd.length >= 8) score += 1
  if (pwd.length >= 12) score += 1
  if (/[a-z]/.test(pwd) && /[A-Z]/.test(pwd)) score += 1
  if (/\d/.test(pwd)) score += 1
  if (/[^A-Za-z0-9]/.test(pwd)) score += 1
  return Math.min(4, score)
}

const Security = ({ language }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [strength, setStrength] = useState(0)
  const t = translations[language] || {}
  const strengthLabels = [t.weak, t.weak, t.fair, t.good, t.strong]

  const onFinish = async ({ currentPassword, newPassword }) => {
    setLoading(true)
    try {
      const response = await secureApi?.post(POST?.CHANGE_PASSWORD, { currentPassword, newPassword })
      if (response?.success) {
        message.success(t.passwordUpdated)
        form.resetFields()
        setStrength(0)
      } else {
        message.error(response?.error || response?.message || t.profileUpdateFailed)
      }
    } catch (error) {
      message.error(t.profileUpdateFailed)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='ps-section'>
      <div className='ps-section-head'>
        <h3>{t.changePassword}</h3>
        <p>{t.changePasswordHint}</p>
      </div>

      <Form form={form} layout='vertical' onFinish={onFinish} requiredMark={false} className='ps-form ps-form-narrow'>
        <Form.Item
          label={t.currentPassword}
          name='currentPassword'
          rules={[{ required: true, message: t.pleaseEnterCurrentPassword }]}
        >
          <Input.Password className='custom-inputs' placeholder={t.currentPassword} prefix={<FaLock className='ps-input-icon' />} autoComplete='current-password' />
        </Form.Item>

        <Form.Item
          label={t.newpassword}
          name='newPassword'
          rules={[
            { required: true, message: t.pleaseEnterYourNewpassword },
            { min: 8, message: t.passwordMustBeatleat },
          ]}
        >
          <Input.Password
            className='custom-inputs'
            placeholder={t.newpassword}
            prefix={<FaLock className='ps-input-icon' />}
            autoComplete='new-password'
            onChange={(e) => setStrength(scorePassword(e.target.value))}
          />
        </Form.Item>

        <div className={`ps-strength ps-strength-${strength}`}>
          <div className='ps-strength-bars'>
            {[1, 2, 3, 4].map((n) => (
              <span key={n} className={strength >= n ? 'on' : ''} />
            ))}
          </div>
          <span className='ps-strength-label'>
            {t.passwordStrength}: {strength > 0 ? strengthLabels[strength] : '-'}
          </span>
        </div>

        <Form.Item
          label={t.confirlnewpassword}
          name='confirmNewPassword'
          dependencies={['newPassword']}
          rules={[
            { required: true, message: t.pleaseConfirmNewpassword },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) return Promise.resolve()
                return Promise.reject(new Error(t.passwordDonotMatch))
              },
            }),
          ]}
        >
          <Input.Password className='custom-inputs' placeholder={t.confirlnewpassword} prefix={<FaLock className='ps-input-icon' />} autoComplete='new-password' />
        </Form.Item>

        <div className='ps-form-actions'>
          <Button type='primary' htmlType='submit' className='add-button ps-save' loading={loading}>
            {t.changePasswrdButton}
          </Button>
        </div>
      </Form>
    </div>
  )
}

export default Security
